import Vue from 'vue'
import App from './App.vue'
import Homepage from "./components/Homepage.vue";
import Resultspage from "./components/Resultspage.vue";
import Chartspage from "./components/Chartspage.vue";
import Errorpage from './components/Errorpage.vue';
import VueGtm from 'vue-gtm';
import VueRouter from 'vue-router'
import axios from 'axios'
import VueClipboard from 'vue-clipboard2'
import BootstrapVue from 'bootstrap-vue'
import Vuex from "vuex";


import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";



Vue.prototype.$http = axios
Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(VueClipboard)
Vue.use(VueGtm, {
  id: 'GTM-5VG3GK2',
  debug: true,
  vueRouter: router
});

Vue.use(Vuex);
Vue.config.productionTip = false;


import BikeDataStore from "./stores/BikeDataStore";

const store = new Vuex.Store({
    modules: {
        BikeDataStore: BikeDataStore,
    },
    strict: false
});


const router = new VueRouter({
	mode: 'history',
  	routes: [
	    { 
	    	path: '/', 
	    	name:'home',
	    	component: Homepage,
	    },
	    { 
	    	path: '/compare/:bikenames/:bikeids', 
	    	name:'results',
	    	component: Resultspage,
	    	props: true,
	    },
	     { 
	    	path: '/charts', 
	    	name:'charts',
	    	component: Chartspage,
	    	props: true,
	    },
	    { 	
	    	path: '*', 
			name: 'error',
	    	component: Errorpage 
	    }
  	]
})

new Vue({ el: '#app', router, store, render: h => h(App) })